import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import Loading from '../loading/loading';
import {TABLE_VIEW_AMOUNTS} from "../../helpers/constants";
import FilterListIcon from "@material-ui/icons/FilterList";
import CustomModal from "../elements/customModal";
import ClearAll from '@material-ui/icons/ClearAll';
import Button from "@material-ui/core/Button/Button";
import TableSortLabel from '@material-ui/core/TableSortLabel';
import _ from 'lodash';
import moment from "moment";
import StoresFilterForm from "../stores/storesFilterForm";
import DepartmentScoresListMobile from "./departmentScoresListMobileView";
import MediaQuery from "react-responsive";
import {getStoreType, scrollToElement} from "../../helpers/functions";
import Info from "@material-ui/icons/Info";
import DepartmentUnScoredCriteriaOfAStore from "./departmentUnScoredCriteriaOfAStore";

const columnData = [
  { id: 'id', numeric: false, disablePadding: false, label: 'Id' },
  { id: 'totalScoredCriteria', numeric: false, disablePadding: false, label: 'Scored Criteria #' },
  { id: 'name', numeric: false, disablePadding: false, label: 'Name' },
  { id: 'dwId', numeric: false, disablePadding: false, label: 'Erp id' },
  { id: 'city', numeric: false, disablePadding: false, label: 'City' },
  { id: 'enterSoftCode', numeric: false, disablePadding: false, label: 'Entersoft code' },
  { id: 'type', numeric: false, disablePadding: false, label: 'Type' },
  { id: 'openDate', numeric: false, disablePadding: false, label: 'Open Date' },
  { id: 'createdDate', numeric: false, disablePadding: false, label: 'Created Date' },
];

class EnhancedTableHead extends React.Component {

  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { onSelectAllClick, numSelected, rowCount, order, orderBy } = this.props;

    return (
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox">
          </TableCell>
          {columnData.map((column, index) => {
            return (
              <TableCell
                key={column.id}
                numeric={column.numeric}
                padding={column.disablePadding ? 'none' : 'default'}
                sortDirection={orderBy === column.id ? order : false}
              >
                <Tooltip
                  title="Sort"
                  placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={order}
                    onClick={this.createSortHandler(column.id)}
                  >
                    {column.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const toolbarStyles = theme => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },
  spacer: {
    flex: '1 1 auto',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
  '@media screen and (max-width: 768px)': {
    root: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap'
    }
  }
});

let EnhancedTableToolbar = props => {
  const { numSelected, classes } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subheading">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="h6" id="tableTitle">
            {`Pending stores to score (Department: ${props.department.name})`}
          </Typography>
        )}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected > 0 ? (
          <Tooltip title="Delete">
            <IconButton aria-label="Delete">
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        ) : <div>
          <Button color="secondary" className={classes.button} onClick={props.clearFilters}>
            Clear filters
            <ClearAll  className={'ml-1'}/>
          </Button>
          <Button color="primary" className={classes.button} onClick={props.openFilterModal}>
            Filter list
            <FilterListIcon className={'ml-1'}/>
          </Button>
        </div>}
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
  },
  table: {
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  '@media screen and (max-width: 768px)': {
    pager: {
      paddingBottom: '8% !important',
    },
    pagerToolbar: {
      flexWrap: 'wrap !important',
      justifyContent: 'center !important'
    }
  }
});

class DepartmentScores extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      order: 'desc',
      orderBy: 'openDate',
      selected: [],
      data: [],
      page: 0,
      rowsPerPage: 100,
      filterModalOpen: false,
      isInfoModalOpen: false,
      selectedStore: null
    };

    this.storesListRef = React.createRef();

  }

  _openInfoModal = (store) => {
    this.setState({
      ...this.state,
      isInfoModalOpen: true,
      selectedStore: store
    })
  };

  _closeInfoModal = () => {
    this.setState({
      ...this.state,
      isInfoModalOpen: false,
      selectedStore: null
    })
  };

  openFilterModal = () => {
    this.setState({
      ...this.state,
      filterModalOpen: true
    })
  };

  closeFilterModal = () => {
    this.setState({
      ...this.state,
      filterModalOpen: false
    })
  };

  filterStores = (formIM) => {
    const whereAndFilter = [];
    if(formIM.get('name')){
      whereAndFilter.push({name: {like: `%25${formIM.get('name')}%25`}})
    }
    if(formIM.get('city')){
      whereAndFilter.push({city: {like: `%25${formIM.get('city')}%25`}})
    }
    if(formIM.get('enterSoftCode')){
      whereAndFilter.push({enterSoftCode: formIM.get('enterSoftCode')})
    }
    if(formIM.get('dwId')){
      whereAndFilter.push({dwId: formIM.get('dwId')})
    }
    if (formIM.get('type') === 'new'){
      whereAndFilter.push({new: true})
    }
    if(formIM.get('type') === 'newComing'){
      whereAndFilter.push({newComing: true})
    }
    if(formIM.get('type') === 'old'){
      whereAndFilter.push({old: true})
    }
    this.props.getStores({
      filter: {where: {and: whereAndFilter}}
    });
    this.closeFilterModal();
  };

  clearFilters = () => {
    this.props.getStores({});
  };

  handleSelectAllClick = (event, checked) => {
    if (checked) {
      this.setState({ selected: this.props.persons.map(n => n.id) });
      return;
    }
    this.setState({ selected: [] });
  };

  handleClick = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    this.setState({ selected: newSelected });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy });
  };

  _changeLocalState = (payload) => {
    this.setState({
      ...this.state,
      [payload.key]: payload.value
    })
  };

  render() {
    const { classes } = this.props;
    const { selected, rowsPerPage, page, order, orderBy } = this.state;
    const data = this.props.pendingStoresToScore;

    return (
      <div>
        <CustomModal
          customStyle={{width: '60%'}}
          open={this.state.isInfoModalOpen}
          handleClose={this._closeInfoModal}
          content={
            <DepartmentUnScoredCriteriaOfAStore
              {...this.props}
              classes={null}
              selectedStore={this.state.selectedStore}
              closePendingCriteriaModal={this._closeInfoModal}
            />
          }
        />
        <CustomModal
          open={this.state.filterModalOpen}
          handleClose={this.closeFilterModal}
          content={
            <StoresFilterForm
              {...this.props}
              filterStores={this.filterStores}
              handleCancel={this.closeFilterModal}
            />
          }
        />
        <Loading displayLoader={this.props.fetchingStores || this.props.fetchingScoreRecords}/>
        <MediaQuery query="(max-device-width: 768px)">
          <DepartmentScoresListMobile
            {...this.props}
            stores={data}
            classes={null}
            clearFilters={this.clearFilters}
            openFilterModal={this.openFilterModal}
            filterStores={this.filterStores}
            handleChangePage={this.handleChangePage}
            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
            _changeLocalState={this._changeLocalState}
            page={page}
            rowsPerPage={rowsPerPage}
            openPendingCriteriaModal={this._openInfoModal}
          />
        </MediaQuery>
        <MediaQuery query="(min-device-width: 769px)">
          <div  ref={this.storesListRef}>
            <Paper className={classes.root}>
              <EnhancedTableToolbar
                {...this.props}
                numSelected={selected.length}
                classes={null}
                openFilterModal={this.openFilterModal}
                clearFilters={this.clearFilters}
              />
              <div className={classes.tableWrapper}>
                <Table className={classes.table + ' table-sm'} aria-labelledby="tableTitle">
                  <EnhancedTableHead
                    numSelected={selected.length}
                    order={order}
                    orderBy={orderBy}
                    onSelectAllClick={this.handleSelectAllClick}
                    rowCount={data.length}
                    onRequestSort={this.handleRequestSort}
                  />
                  <TableBody>
                    {_.orderBy(data, item => {
                      if(orderBy === 'type'){
                        return getStoreType(item)
                      }

                      return item[orderBy]
                    }, order)
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map(n => {
                        const isSelected = this.isSelected(n.id);
                        const storeTotalCriteria = this.props._getTotalStoreCriteria(n);
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            aria-checked={isSelected}
                            tabIndex={-1}
                            key={n.id}
                            selected={isSelected}
                          >
                            <TableCell padding="checkbox">
                              <IconButton
                                aria-label="Edit criterion"
                                onClick={() => this._openInfoModal(n)}>
                                <Info/>
                              </IconButton>
                            </TableCell>
                            <TableCell>
                              {n.id}
                            </TableCell>
                            <TableCell>
                              {`${n.totalScoredCriteria} / ${storeTotalCriteria}`}
                            </TableCell>
                            <TableCell>
                              {n.name}
                            </TableCell>
                            <TableCell >
                              {n.dwId}
                            </TableCell>
                            <TableCell >
                              {n.city}
                            </TableCell>
                            <TableCell >
                              {n.enterSoftCode}
                            </TableCell>
                            <TableCell >
                              {getStoreType(n)}
                            </TableCell>
                            <TableCell >
                              {moment(n.openDate).isValid()?moment(n.openDate).format('DD/MM/YYYY HH:mm:ss'):''}
                            </TableCell>
                            <TableCell >
                              {moment(n.createdDate).isValid()?moment(n.createdDate).format('DD/MM/YYYY HH:mm:ss'):''}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </div>
              <TablePagination
                classes={
                  {
                    root: classes.pager,
                    toolbar: classes.pagerToolbar
                  }
                }
                rowsPerPageOptions={TABLE_VIEW_AMOUNTS}
                component="div"
                count={data.length}
                rowsPerPage={rowsPerPage}
                page={page}
                backIconButtonProps={{
                  'aria-label': 'Previous Page',
                }}
                nextIconButtonProps={{
                  'aria-label': 'Next Page',
                }}
                onChangePage={(evt, page) => {
                  scrollToElement(this.storesListRef.current);
                  this.handleChangePage(evt, page)
                }}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
              />
            </Paper>
          </div>
        </MediaQuery>
      </div>
    );
  }
}

DepartmentScores.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DepartmentScores);



// WEBPACK FOOTER //
// ./src/components/department/departmentScores.js